import { SxProps, Theme } from '@mui/material';

/**
 * Styles used for MenuAppBar and MenuLinks components
 */
export const menuAppBarStyles: Record<string, SxProps<Theme>> = {
  // App bar container
  appBar: {
    backgroundColor: 'var(--menu-app-bar)',
    boxShadow: 'none',
  },

  // App bar toolbar (inside content)
  toolbar: {
    px: 2,
    display: 'flex',
    alignItems: 'center',
    minHeight: 'var(--menu-bar-height)',
    justifyContent: 'space-between',
  },

  // Mobile hamburger icon
  hamburger: {
    mr: 2,
    display: { xs: 'block', md: 'none' },
  },

  // Logo box (left section of app bar)
  logoBox: {
    display: { xs: 'none', md: 'block' },
  },

  // Logo image
  logoImg: {
    width: 120,
    display: 'block',
  },

  // Container for the tabs section
  tabsContainer: {
    flexGrow: 1,
    display: { xs: 'none', md: 'flex' },
    justifyContent: 'center',
  },

  // Tabs indicator (the underline)
  tabIndicator: {
    backgroundColor: '#1363DF',
    height: 3,
  },

  // Base tab style (applies to all tabs)
  tab: {
    px: { xs: 1, md: 2, lg: 3 },
    minWidth: 0,
    textTransform: 'none',
    // minHeight: '70px',
  },

  // Style for selected (active) tab
  tabSelected: {
    color: '#fff',
    fontWeight: 700,
    borderBottom: '3px solid #fff',
    fontSize: { md: '0.875rem', lg: '1rem' },
    minHeight: '70px',
  },

  // Style for unselected tab
  tabUnselected: {
    color: 'rgba(255,255,255,0.9)',
    fontWeight: 500,
    borderBottom: '3px solid transparent',
    fontSize: { md: '0.875rem', lg: '1rem' },
    minHeight: '70px',
  },

  // Dropdown menu container style
  menuPaper: {
    mt: 1,
    borderRadius: 2,
    minWidth: 200,
  },

  // Style for each item inside dropdown
  menuItem: {
    px: 3,
    py: 1.5,
    textTransform: 'none',
  },

  // Right-side user control section (notifications, avatar, etc.)
  userControls: {
    display: 'flex',
    alignItems: 'center',
    gap: 1,
  },
  searchField: {
    p: 0.5,
    pt: 1,
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: 'transparent', // hides normal border if needed
      },
      '&:hover fieldset': {
        borderColor: 'transparent',
      },
      '&.Mui-focused fieldset': {
        borderColor: 'transparent',
      },
    },
    '& .MuiOutlinedInput-input:focus': {
      outline: 'none', // removes native blue ring
    },
  },
  searchDialog: { ['& .MuiDialog-container']: { alignItems: 'flex-start' } },
};
